import { createStyles } from '@svg/antd/es/theme/utils';

export default createStyles(({ token, css }) => {
    return {
        blankEntryContainer: css`
            width: 100%;
            height: 100%;
            background: transparent;
            animation: fadeIn 0.3s ease-in-out;
            
            @keyframes fadeIn {
                from {
                    opacity: 0;
                }
                to {
                    opacity: 1;
                }
            }
        `,
    }
});

